import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { get_all_item_discount } from "../../../api/admin/coupons";
import { TbDiscount2 } from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import { FaTrashCan } from "react-icons/fa6";
import { IoMdArrowBack } from "react-icons/io";
import { isDisabled } from "../../../reducers/common";
import { Checkbox } from "antd";
import { totalAmout } from "../../../helpers";
import { orderPaymentType } from "../../../assets/constants/constant";
import CommonButton from "../../../reusable/Button";

let obj = { page: 1, pageSize: 500, isEndUser: true };

const CheckoutSummary = ({
  orderDetail,
  shippingCharge,
  step,
  isShow,
  setVisible,
  stepHandler,
  setStep,
  setIsShow,
  orderSummary,
  setOrderSumarry,
  couponCode,
  setCouponCode,
  couponHandler,
  deleteHandler,
  rewardHandler,
  dicountData,
  paymentType,
  setPaymentType,
  setPaymentTypeHandler,
  orderHandler,
  loading,
}) => {
  const param = useParams();
  const dispatch = useDispatch();
  const { total_amount } = useSelector((state) => state.cart);
  const { isLoading, isLoadings } = useSelector((state) => state.order);
  const { userRewards } = useSelector((state) => state.common);

  return (
    <div>
      {!step ? (
        <>
          <div className="cartTotals form-control mb-3">
            <div className="row ">
              <div className="col-6   ">
                <h6>Sub Total:</h6>
              </div>
              <div className="col-6 text-end">
                <span className="text-end fw-600">
                  ${total_amount?.toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <span
            onClick={() => {
              setVisible(true);
              dispatch(get_all_item_discount(obj));
            }}
            className="mb-3 form-control d-flex justify-content-between align-items-center cursor-pointer"
          >
            <TbDiscount2 size={22} />
            <h6 className="p-0 mt-2">View all discounts</h6>
          </span>
          <div>
            <CommonButton
              type="submit"
              disabled={isLoading ? true : false}
              className="button w-100 px-4 rounded-1 py-2 "
              onClick={() => stepHandler()}
            >
              {loading ? (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Proceed to Payment"
              )}
            </CommonButton>
          </div>
        </>
      ) : (
        <>
          <span
            className="cursor-pointer mb-2"
            onClick={() => {
              setStep(false);
              setIsShow(false);
              dispatch(isDisabled(false));
              setOrderSumarry({
                ...orderSummary,
                discountType: "",
                discount: "",
              });
            }}
          >
            <IoMdArrowBack size={22} /> Back
          </span>
          {orderSummary?.discountType !== "coupon" && (
            <div className="row my-3" style={{ margin: "0px !important" }}>
              <div className="col-md-9">
                <input
                  type="text"
                  placeholder="Enter coupon code"
                  className="form-control"
                  name="couponCode"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  class="btn out_line_btn px-2"
                  onClick={() => couponHandler()}
                >
                  {isLoadings ? (
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Apply"
                  )}
                </button>
              </div>
            </div>
          )}

          {orderSummary?.discountType === "coupon" && (
            <div
              className="row my-3"
              style={{
                margin: "0px !important",
                padding: "0px 12px",
              }}
            >
              <div
                className="form-control d-flex justify-content-between"
                style={{ paddingBottom: "0px" }}
              >
                <span className="d-flex mt-1">
                  <p>
                    <FaCheckCircle size={18} className="color-green" />
                  </p>
                  <h6 className="ms-3 color-green">{couponCode}</h6>
                </span>
                <span className="cursor-pointer" onClick={deleteHandler}>
                  <FaTrashCan className="text-danger" />
                </span>
              </div>
            </div>
          )}

          <div className="cartTotals form-control mb-3">
            <div className="row ">
              <div className="col-6   ">
                <h6>Sub Total:</h6>
              </div>

              <div className="col-6 text-end">
                <span className="text-end fw-600">
                  ${total_amount.toFixed(2)}
                </span>
              </div>
            </div>

            <div className="row pt-1">
              <div className="col-7">
                <h6>Shipping Charges:</h6>
              </div>
              <div className="col-5 text-end ">
                <span className="text-end fw-600">
                  ${shippingCharge.toFixed(2)}
                </span>
              </div>
            </div>

            {isShow && (
              <div className="row pt-1">
                <div className="col-7">
                  <h6>
                    {orderSummary?.discountName === "items"
                      ? "Items"
                      : "Coupon"}{" "}
                    Discount:
                  </h6>
                </div>
                <div className="col-5 text-end ">
                  <span className="text-end color-green fw-600">
                    - ${orderSummary?.discount?.toFixed(2)}
                  </span>
                </div>
              </div>
            )}

            {userRewards > 0 && (
              <div className="row pt-1">
                <div className="col-7">
                  <h6>My Rewards:</h6>
                </div>
                <div className="col-5 text-end ">
                  <span className="text-end color-green fw-600">
                    <span>${userRewards.toFixed(2)}</span>
                    <span className="ms-1" style={{ marginRight: "-20px" }}>
                      <Checkbox
                        checked={dicountData?.useRewardPoints}
                        onChange={() => rewardHandler()}
                      ></Checkbox>
                    </span>
                  </span>
                </div>
              </div>
            )}
            <hr className="my-3" />
            <div className="row pt-1">
              <div className="col-6">
                <h6 className="ad-text-dark">Total Amount:</h6>
              </div>

              <div className="col-6 text-end">
                <span className="fw-bold">
                  $
                  {totalAmout(
                    total_amount,
                    dicountData?.useRewardPoints ? userRewards : 0,
                    orderSummary?.shippingCharges,
                    orderSummary?.discount
                  ).toFixed(2)}
                </span>
              </div>
            </div>

            <div className="row my-2">
              <div className="col-md-12 d-flex align-items-center justify-content-center ">
                <h5 className="ad-text-dark">Payment Type</h5>
              </div>
              <div className="col-md-12 ">
                <div className="d-flex justify-content-between">
                  <h6>Bank Transfer (EMT)</h6>
                  <input
                    checked={paymentType === orderPaymentType?.banktransfer}
                    type="radio"
                    name=""
                    id=""
                    onClick={() => {
                      setPaymentType(1);
                      setPaymentTypeHandler(1);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-between">
                  <h6>Bitcoin </h6>
                  <input
                    checked={paymentType === orderPaymentType?.bitcoin}
                    type="radio"
                    name=""
                    id=""
                    onClick={() => {
                      setPaymentType(2);
                      setPaymentTypeHandler(2);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <CommonButton
              type="submit"
              disabled={isLoading ? true : false}
              className="button w-100 px-4 rounded-1 my-3 py-2 "
              onClick={() => orderHandler()}
            >
              {isLoading ? (
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Place Order"
              )}
            </CommonButton>
          </div>
        </>
      )}
    </div>
  );
};

export default CheckoutSummary;
